import React, {useContext} from 'react';
import './ProfileGeneral.less';
import {ProfilePicker} from "compositions/profile-picker/ProfilePicker";
import {ProfilePickerTrigger} from "elements/profile-picker-trigger/ProfilePickerTrigger";
import {List} from "elements/list/List.tsx";
import {ListItem} from "elements/list-item/ListItem.tsx";
import {TranslationsContext} from "contexts/translations-context";
import {getSafeTranslation} from "helpers/localization.helper.ts";

export const ProfileGeneral = ({
																 phone,
																 onPhoneClick,
																 name,
																 onNameClick,
																 email,
																 onEmailClick,
																 birthday,
																 onBirthdayClick,
																 card,
																 onCardClick
															 }) => {
	const translations = useContext(TranslationsContext);

	return <List>
		<ListItem key="phone" onClick={onPhoneClick} isResponsive>
			<ProfilePicker title={getSafeTranslation('ProfileGeneral.phoneLabel', translations)}>
				<ProfilePickerTrigger text={phone}/>
			</ProfilePicker>
		</ListItem>
		<ListItem key="name" onClick={onNameClick} isResponsive>
			<ProfilePicker title={getSafeTranslation('ProfileGeneral.nameLabel', translations)}>
				<ProfilePickerTrigger text={name}/>
			</ProfilePicker>
		</ListItem>
		<ListItem key="email" onClick={onEmailClick} isResponsive>
			<ProfilePicker title={getSafeTranslation('ProfileGeneral.emailLabel', translations)}>
				<ProfilePickerTrigger text={email}/>
			</ProfilePicker>
		</ListItem>
		<ListItem key="birthday" onClick={onBirthdayClick} isResponsive>
			<ProfilePicker title={getSafeTranslation('ProfileGeneral.birthdayLabel', translations)}>
				<ProfilePickerTrigger text={birthday}/>
			</ProfilePicker>
		</ListItem>
		{
			card && (
				<ListItem key="card" onClick={onCardClick} isResponsive>
					<ProfilePicker title={getSafeTranslation('ProfileGeneral.creditCardLabel', translations)}>
						<ProfilePickerTrigger text={card}/>
					</ProfilePicker>
				</ListItem>
			)
		}
	</List>
}
